import styles from './index.module.css'

import { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import FoldingFrame from '../FoldingFrame'
import FoldingContentTable from '../FoldingContentTable'
import ImageOverview from '../ImageOverview'
import { transformImageSpecifications } from '../../../../utils'
import ModalImageView from '../../../../common/ModalImageView'


function ImageDetail({imageData, loading, error}) {
    const [specifications, setSpecifications] = useState([])
    const [imageUrl, setImageUrl] = useState('')
    const [imageDetailUrl, setImageDetailUrl] = useState([])
    const [isImageModalOpen, setIsImageModalOpen] = useState(false)
    const [showImageUrl, setShowImageUrl] = useState('')

    useEffect(() => {
        let d = JSON.parse(imageData?.meta_data?.specifications ?? '{}')
        setSpecifications(transformImageSpecifications(d))

        let url = imageData?.url ?? ''
        setImageUrl(url)
        let urls = imageData?.meta_data?.detail_url ?? []
        setImageDetailUrl(urls)
    }, [imageData])

    return (
        <div className={styles.container}>
            {
                loading ? (
                    <div className={styles.section_error}>数据获取中...</div>
                ) : (
                    error ? (
                        <div className={styles.section_error}>数据获取失败</div>
                    ) : null
                )
            }

            {
                !loading && !error ? (
                    <div className={styles.section}>
                        <ImageOverview
                            data={imageData}
                            imageUrl={imageUrl}
                            setIsImageModalOpen={setIsImageModalOpen}
                            setShowImageUrl={setShowImageUrl}
                        />
                    </div>
                ) : null
            }

            {
                !loading && !error ? (
                    <>
                        <div className={styles.div_line}></div>

                        <div className={styles.section}>
                            <FoldingFrame
                                title="规格属性"
                                content={<FoldingContentTable specifications={specifications} />}
                            />
                        </div>

                        <div className={styles.section}>
                            <FoldingFrame
                                title="产品详情"
                                content={
                                    imageDetailUrl.length === 0 ? "无图片" : (
                                        imageDetailUrl.map((item, index) => {
                                            return (
                                                <div>
                                                    <img src={item} alt="img" style={{maxWidth: '100%', height: 'auto', marginBottom: '16px'}} key={item} />
                                                </div>
                                            )
                                        })
                                    )
                                }
                            />
                        </div>
                    </>
                ) : null
            }

            <ModalImageView
                isModalOpen={isImageModalOpen}
                setIsModalOpen={setIsImageModalOpen}
                showImageUrl={showImageUrl}
                setShowImageUrl={setShowImageUrl}
            />
        </div>
    )
}

export default ImageDetail